import SortableList, { SortableItem } from "react-easy-sort";
import { imgUrl } from "../../utils/imageUpload.utils";
import Button from "../Button";
import { DeleteIcon } from "../../utils/icon.utils";
import { arrayMap } from "../../utils/array.utils";

export default function ImagePreviewer({ images, setImages }) {
  const handleRemove = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  function arrayMove(array, fromIndex, toIndex) {
    if (fromIndex === toIndex) {
      return array.slice();
    }

    const newArray = array.slice();
    const item = newArray.splice(fromIndex, 1)[0];
    newArray.splice(toIndex, 0, item);

    return newArray;
  }

  const onSortEnd = (oldIndex, newIndex) => {
    setImages((array) => arrayMove(array, oldIndex, newIndex));
  };

  return (
    <>
      <p> {images?.length > 0 ? `Total: ${images?.length}` : ""}</p>
      <SortableList onSortEnd={onSortEnd} draggedItemClassName="image" className="row g-3 mb-4">
        {arrayMap(images, (item, index) => (
          <SortableItem key={index}>
            <div className="col-6 col-md-2">
              <div className="position-relative">
                <img
                  src={imgUrl(item)}
                  alt={`car-${index}`}
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
                <Button
                  onClick={() => handleRemove(index)}
                  color="danger"
                  icon={DeleteIcon}
                  style={{ position: "absolute", top: "5px", right: "5px" }}
                />
              </div>
            </div>
          </SortableItem>
        ))}
      </SortableList>
    </>
  );
}
